<template>
    <div class="msite-nav">
        <div class="msite-nav-top" style="direction: ltr">
<!--            <div class="msite-nav-top">-->
<!--                <i class="nav-close"><img src="/assets/images/nav-close.svg" alt=""/></i>-->
<!--                <span v-if="$store.state.language.code === 'ar'"><a href="https://thecradle.co">English <i><img src="/assets/images/lung.svg"-->
<!--                                                                                                                alt=""/></i></a></span>-->
<!--                <span v-else><a href="https://thecradlearabic.com">عربي <i><img src="/assets/images/lung.svg" alt=""/></i></a></span>-->
<!--            </div>-->
            <i class="nav-close"><img src="/assets/images/nav-close.svg" alt=""/></i>
            <div style="position: relative">
                <div id="language-dropdown-toggle-mobile" style="display: flex;gap: 5px" @click="toggleElementById('language-dropdown-mobile')">
                    <span v-if="$store.state.language.code === 'en'">English</span>
                    <span v-if="$store.state.language.code === 'ar'">عربي</span>
                    <span v-if="$store.state.language.code === 'tr'">Türkçe</span>
                    <img src="/assets/images/lung.svg" alt=""
                         style="cursor: pointer"/></div>
                <div id="language-dropdown-mobile" class="opacity-0 pointer-events-none language-dropdown" style="">
                    <a style="padding: 8px 12px;color: black;" href="https://thecradle.co">English</a>
                    <a style="padding: 8px 12px;color: black;" href="https://thecradlearabic.com">عربي</a>
                    <a style="padding: 8px 12px;color: black;" href="https://thecradleturkiye.com">Türkçe</a>
                </div>
            </div>
        </div>
        <nav>
            <ul>
                <li>
                    <a class="active" :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a>
                </li>
                <li v-for="category in categories"><a
                    :href="$store.state.hrefPrefix + '/category/' + category.slug">
                    {{ category.category_languages[0].pivot.name }}
                </a></li>
                <li v-if="$store.state.language.code !== 'ar'"><a :href="$store.state.hrefPrefix + '/podcast'">{{
                        $t('podcast')
                    }}</a></li>
                <li class="sub-menu">
                    <a href="#" class="msite-nav-click">{{ $t('columns') }}</a>
                    <ul class="sub-menu-click">
                        <li v-for="column in columns"><a
                            :href="$store.state.hrefPrefix + '/columns/' + column.slug" title="columns">
                            {{ column.author_languages[0].pivot.name }}</a>
                        </li>
                    </ul>
                </li>

            </ul>
        </nav>
        <ul class="msite-btn">
            <li v-if="$store.state.language.code !== 'tr'" class="msite-support"><a href="https://donate.thecradle.co" target="_blank"> {{ $t('support_us') }} <i><img src="/assets/images/heart-icon.svg"
                                                                                  alt=""></i></a></li>
            <li><a :href="$store.state.hrefPrefix + '/account/author'"> {{ $t('become_an_author') }} <i><img
                src="/assets/images/author-icon.svg" alt=""/></i></a></li>
            <li v-if="$store.state.user.id == null"><a href="/account/login">{{ $t('log_in') }} <i><img
                src="/assets/images/user-icon.svg" alt=""/></i></a></li>
            <li class="myprofile-click" v-else><a href="#">{{ $t('my_profile') }} <i><img
                src="/assets/images/user-icon.svg" alt=""/></i></a></li>
            <ul class="myprofile-open">
                <li><i><img src="/assets/images/Settings-icon.svg" alt=""></i><a
                    :href="$store.state.hrefPrefix + '/user/profile'">{{ $t('profile_settings') }}</a></li>
                <li><i><img src="/assets/images/Comments-icon.svg" alt=""></i><a
                    :href="$store.state.hrefPrefix + '/user/comments'">{{ $t('my_comments') }}</a></li>
                <li class="logout-click"><i><img src="/assets/images/logout-icon.svg" alt=""></i><a
                    href="#">{{ $t('log_out') }}</a></li>
            </ul>
        </ul>
        <ul class="msite-links">
            <li v-if="$store.state.language.code === 'ar'">
                <a href="https://www.facebook.com/thecradlearabi/" target="_blank">
                    <img src="/assets/images/fb.svg?v=2"
                         onmouseover="this.src='/assets/images/fb-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/fb.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else-if="$store.state.language.code === 'tr'">
                <a href="https://www.facebook.com/profile.php?id=61573869121346" target="_blank">
                    <img src="/assets/images/fb.svg?v=2"
                         onmouseover="this.src='/assets/images/fb-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/fb.svg?v=2'" alt=""/>
                </a>
            </li>
            <template v-else>
                <li>
                    <a href="https://www.youtube.com/@thecradlemedia" target="_blank">
                        <img style="width: 22px" src="/assets/images/youtube.svg?v=2"
                             onmouseover="this.src='/assets/images/youtube-hover.svg?v=2'"
                             onmouseout="this.src='/assets/images/youtube.svg?v=2'" alt=""/>
                    </a>
                </li>
                <li>
                    <a href="https://www.patreon.com/thecradlemedia" target="_blank">
                        <img style="width: 20px" src="/assets/images/patreon-icon.svg?v=2"
                             onmouseover="this.src='/assets/images/patreon-icon-hover.svg?v=2'"
                             onmouseout="this.src='/assets/images/patreon-icon.svg?v=2'" alt=""/>
                    </a>
                </li>
            </template>

            <li v-if="$store.state.language.code === 'ar'">
                <a href="https://www.instagram.com/thecradlearabi/" target="_blank">

                    <img src="/assets/images/insta.svg?v=2"
                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/insta.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else-if="$store.state.language.code === 'tr'">
                <a href="https://www.instagram.com/cradleturkiye" target="_blank">
                    <img src="/assets/images/insta.svg?v=2"
                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/insta.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else>
                <a href="https://www.instagram.com/tcmedianews" target="_blank">

                    <img src="/assets/images/insta.svg?v=2"
                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/insta.svg?v=2'" alt=""/>
                </a>
            </li>



            <li v-if="$store.state.language.code === 'ar'">
                <a href="https://twitter.com/TheCradleArabi" target="_blank">
                    <img src="/assets/images/twitter.svg?v=2"
                         onmouseover="this.src='/assets/images/twitter-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/twitter.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else-if="$store.state.language.code === 'tr'">
                <a href="https://x.com/cradleturkiye" target="_blank">
                    <img src="/assets/images/twitter.svg?v=2"
                         onmouseover="this.src='/assets/images/twitter-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/twitter.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else>
                <a href="https://twitter.com/thecradlemedia" target="_blank">
                    <img src="/assets/images/twitter.svg?v=2"
                         onmouseover="this.src='/assets/images/twitter-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/twitter.svg?v=2'" alt=""/>
                </a>
            </li>
            <!--            <li>-->
            <!--                <a href="https://chat.whatsapp.com/Bh9zpaIEcsc2axXA4ZQAhy" target="_blank"><img src="/assets/images/whatsup.svg" alt="" /></a>-->
            <!--            </li>-->
            <li v-if="$store.state.language.code === 'ar'">
                <a href=" https://t.me/thecradlearabi" target="_blank">
                    <img src="/assets/images/links.svg?v=2"
                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/links.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else-if="$store.state.language.code === 'tr'">
                <a href="https://t.me/cradleturkiye" target="_blank">
                    <img src="/assets/images/links.svg?v=2"
                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/links.svg?v=2'" alt=""/>
                </a>
            </li>
            <li v-else>
                <a href="https://t.me/thecradlemedia" target="_blank">
                    <img src="/assets/images/links.svg?v=2"
                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                         onmouseout="this.src='/assets/images/links.svg?v=2'" alt=""/>
                </a>
            </li>
            <li>
                <a :href="$store.state.hrefPrefix + '/feed'" target="_blank"><img src="/assets/images/rss-icon.svg"
                                                                                  alt=""/></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "MsiteNav",
    props: {
        categories: {
            type: Array,
            default: []
        },
        columns: {
            type: Object,
            default: []
        },

    },
    methods: {
        toggleElementById(Id) {
            const dropDown = document.getElementById(Id);
            dropDown.classList.toggle('opacity-0');
            dropDown.classList.toggle('pointer-events-none');
        },
        handleClickAwayMobile(event) {
            const element = document.getElementById('language-dropdown-toggle-mobile')
            const dropDown = document.getElementById('language-dropdown-mobile');
            if (element && !element.contains(event.target) && !dropDown.contains(event.target)) {
                dropDown.classList.add('opacity-0');
                dropDown.classList.add('pointer-events-none');
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickAwayMobile);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickAwayMobile);
    },
}

</script>

<style scoped>
.opacity-0 {
    opacity: 0;
}

.pointer-events-none {
    pointer-events: none;
}

.language-dropdown {
    background: white;
    z-index: 10000;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    position: absolute;
    padding: 10px 0;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    display: flex;
    flex-direction: column;
    left: -60px;
    top: 25px;

}
</style>
